import biLogger from 'web-bi-logger';
import mapValues from 'lodash/mapValues';
import findKey from 'lodash/findKey';

export const VOD_SRC_ID = 71;

const createBiLogger = ({ events, defaults, disableBi, logBiSend }) => {
  const knownEvents = mapValues(events, evid => ({ evid }));

  const biFactory = biLogger
    .factory({ endpoint: 'video' })
    .setDefaults(defaults)
    .setEvents(knownEvents);

  if (disableBi) {
    biFactory._publishers.splice(0, 1);
  }

  if (logBiSend) {
    biFactory.addPublisher(event => {
      console.warn('bi:', findKey(knownEvents, { evid: event.evid }), event.eventName || event); // eslint-disable-line no-console
    });
  }

  return biFactory.logger();
};


export default createBiLogger;



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/bi/create-bi-logger.js